import Vue from "vue";
import Router from "vue-router";
import Player from "./views/Player.vue";
import HostingPlayer from "./views/HostingPlayer.vue";
import Preview from "./views/Editor/Preview.vue";
import List from "./views/Editor/List.vue";
import Detail from "./views/Editor/Detail.vue";
import Inline from "./views/TestViews/Inline.vue";
import Fillscreen from "./views/TestViews/Fillscreen.vue";
import ExternalAudio from "./views/TestViews/ExternalAudio.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "player",
      component: Player,
      meta: { hasNav: false }
    },
    {
      path: "/editor/:id/",
      name: "detail",
      component: Detail,
      meta: { hasNav: false }
    },
    {
      path: "/editor/:id/import/",
      name: "import",
      component: Detail,
      meta: { hasNav: false }
    },
    {
      path: "/editor/:id/edit/",
      name: "edit",
      component: Detail,
      meta: { hasNav: false }
    },
    {
      path: "/editor/",
      name: "editor-list",
      component: List,
      meta: { hasNav: false }
    },
    {
      path: "/editor/:id/preview/",
      name: "preview",
      component: Preview,
      meta: { hasNav: false }
    },
    {
      path: "/preview/:id",
      name: "hosting-player",
      component: HostingPlayer,
      meta: { hasNav: false, exact: true }
    },
    {
      path: "/preview/:id/fill",
      name: "hosting-player-fill",
      component: HostingPlayer,
      meta: { hasNav: false, fill: true }
    },
    {
      path: "/tests/inline/:id",
      name: "tests-inline",
      component: Inline,
      meta: { hasNav: false, exact: true }
    },
    {
      path: "/tests/fillscreen/:id",
      name: "tests-fillscreen",
      component: Fillscreen,
      meta: { hasNav: false, exact: true }
    },
    {
      path: "/tests/external-audio/:id",
      name: "tests-external-audio",
      component: ExternalAudio,
      meta: { hasNav: false, exact: true }
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
